import { createFileRoute } from '@tanstack/react-router'
import { PublicShortlistPage } from '@/features/candidates/components/public-shortlist-page'

export const Route = createFileRoute('/sl/$shareToken')({
  component: PublicShortlistPage,
})
